import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6 py-10">
      <div className="w-full max-w-md border border-neutral-200 bg-white rounded-xl p-8">
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-500 mb-3">LOG IN</div>
        <h1 className="font-display font-black tracking-tighter text-3xl mb-6">Welcome back.</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <Label>Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11" data-testid="login-email" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-full" data-testid="login-submit">
            {loading ? "…" : "Log in"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-neutral-600 text-center">
          No account? <Link to="/signup" className="underline underline-offset-4 hover:text-[#FF4500]">Sign up</Link>
        </div>
      </div>
    </div>
  );
}
